import { render, staticRenderFns } from "./BusinessFreeConfig.vue?vue&type=template&id=1b9cef76&lang=html"
import script from "./BusinessFreeConfig.vue?vue&type=script&lang=js"
export * from "./BusinessFreeConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports